/*
 * File: LeavePageWidget.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 21, 2025 at 2:11 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	position: fixed;
	bottom: ${({ $offset }) => ($offset + 20)}px;
	right: 20px;
	display: flex;
	flex-direction: column;
	gap: 6px;
	z-index: 99;

	& > div {
		justify-content: end;
	}
`;

export const LeavePageFab = styled.div`
	width: 71px;
	height: 71px;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.primaryButton};
	text-align: center;
	box-shadow: ${({ theme }) => theme.elementShadow};
	opacity: 1;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 8px 11px;

	&:hover {
		opacity: 0.8;
	}
	h4 {
		font-size: 0.78rem;
		color: ${({ theme }) => theme.primaryBackground};
	}
	svg {
		font-size: 1.0rem;
		color: ${({ theme }) => theme.primaryBackground};
	}
	&.leaveFab {
		margin-bottom: 40px;
	}
	&.resourcesFab {
		width: auto;
		min-width: 71px;
		height: auto;
	}
`;
